export const VersionState = {
  initialVersion: undefined as string | undefined,
  firstTimeLoading: true,
  currentVersion: undefined as string | undefined,
  hasNewVersion: false,
};
